<template>
  <div class="mainContent">
    <h3 class="title">{{ introduce.ourTitle }}</h3>
    <div class="link"></div>
    <p class="text" v-html="introduce.ourContent"></p>
    <div class="download" v-if="introduce.ourFile">
      <div>附件下载：</div>
      <div @click="handleDownLoad">{{ introduce.ourTitle }}</div>
      <!-- <a href="javascript:;" @click="handleDownLoad">{{
        constitution.ourTitle
      }}</a> -->
    </div>
  </div>
</template>

<script>
import { downloadFileStream } from "@/utils/tools";
export default {
  name: "introduce",
  data() {
    return {
      introduce: "",
    };
  },
  mounted() {
    this.getIntroduce();
  },
  methods: {
    getIntroduce() {
      this.$axios({
        method: "post",
        url: "/laf/laf/lafOur/find.ajax",
        data: {
          pkValue: "1",
          _entityName: "org.aweto.laf.entity.LafOur",
        },
      })
      .then((res) => {
        // console.log(res);
        this.introduce = res.recorder;
        // console.log(this.introduce);
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    async handleDownLoad() {
      const res1 = await this.$axios({
        method: "post",
        url: "/laf/laf/lafOur/find.ajax",
        data: {
          pkValue: "1",
          _entityName: "org.aweto.laf.entity.LafOur",
        },
      });

      // 根据fileUrl获取附件信息
      const res2 = await this.$axios({
        method: "post",
        url: "/laf/attach/attachInfo/attachList.ajax",
        data: {
          fileId: res1.recorder.ourFile,
        },
      });
      const {
        localType,
        localAddress,
        username,
        password,
        filePath,
        saveName,
        fileName,
        fileType,
        id: infoNo
      } = res2[0];

      // 下载附件
      const res3 = await this.$axios({
        method: "post",
        url: "/laf/fileDownloadServlet",
        data: {
          localType,
          localAddress,
          username,
          password,
          filepath: filePath,
          saveName,
          fileName,
          fileType,
          pathType: "absolute",
          encode: "UTF-8",
          infoNo,
          viewMode:false
        },
        responseType: "blob",
      });
      downloadFileStream(res3, fileName);
    },
  },
};
</script>

<style lang='scss' scoped>
.mainContent {
  .title {
    text-align: center;
    font-size: 20px;
    color: #333333;
  }
  .link {
    height: 1px;
    margin: 24px 0;
    background-color: #e5e5e5;
  }
  .text {
    font-size: 14px;
    // padding: 20px;
    padding-left: 20px;
  }
}

.download {
  margin-left: 20px;
  font-size: 16px;
  margin-top: 40px;
  margin-bottom: 20px;
}
.download :nth-child(2) {
  font-size: 14px;
  margin-top: 10px;
  color: #dc2725;
  cursor: pointer;
  margin-left: 32px;
  &:hover {
    text-decoration: underline;
  }
}
</style>